import { useCallback } from 'react';
import { booleanPointInPolygon } from '@turf/boolean-point-in-polygon';
import * as turf from '@turf/helpers';
import { Cartographic, Math as CesiumMath } from 'cesium';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';

export function useOverlappingPaddocks() {
    const paddocks = useEntities('Paddock');

    const overlappingPaddocks = useCallback(
        (mousePosition: Cesium.Cartesian3) => {
            return Array.from(paddocks.values()).filter(({ geometry }) => {
                const turfPoly = turf.polygon(geometry.coordinates);
                const cartPoint = Cartographic.fromCartesian(mousePosition);
                const turfPoint = turf.point([
                    CesiumMath.toDegrees(cartPoint.longitude),
                    CesiumMath.toDegrees(cartPoint.latitude),
                ]);
                return booleanPointInPolygon(turfPoint, turfPoly);
            });
        },
        [paddocks],
    );

    return { overlappingPaddocks };
}
